// routes
import { routes } from "../../../features/routes/route.tsx";
// axios
import axios from "axios";
// data type
import { Otp } from "../../../data/agent/otp.tsx";
// @ts-ignore
import Cookies from "js-cookie";

export const CheckOtpCode = async (data: Otp) => {
    let token = Cookies.get('agent_token');
    let ClientOption: any = {
        headers: {
            'APIKEY': process.env.REACT_APP_API_CLIENT_KEY,
            Authorization: `Bearer ${token}`,
        }
    };
    const { data: response } = await axios.post(`${routes.api[0].address}/agent/check-otp`, data, ClientOption);
    return response.data;
}